import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import SupportBusiness from "../components/SupportBusiness";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportBusiness);
const withTranslationComponent = withTranslation(["supportBusiness", "support", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/SupportBusiness.js